import React, { useState } from 'react';
import styled from 'styled-components';
import InfoRed from '../assets/images/infoRed.png';
import { useAuth } from '../providers/AuthProvider';
import { POST } from '../services/HttpRequests';
import { generateRecaptcha } from '../services/Recaptcha';
import AlohaaLogo from '../assets/images/AlohaaLogoWhite.png';
const orgUrl = process.env.REACT_APP_ORGANIZATION_API;
const regex = /^[a-zA-Z]+$/;


const GradientDiv = styled.div`
  height: 98px;
  background: linear-gradient(#f8153b, #920c23);
  display: flex;
  flex-direction: row;
`;

const DailerDiv = styled.div`
  height: '295px';
  background: 'white';
  border-radius: '0px 0px 10px 10px';
`;

const VerifyOtpButton = styled.div`
  width: 230px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 32px;
  background: var(--Alohaa-Green, #07aa3f);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

function TwoFAAuthentication(props) {
  const { is_2FA_enabled, secret, password, ...res } = props;
  const { saveSession } = useAuth();
  const [otpResent, setOtpResent] = useState(false);
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [otpSentTo, setOTPSentTo] = useState(res.user?.zvr_mobile_no || res.user?.email || '')
  let username = '';
  if (res.role === 'USER') {
    username = res.user?.zvr_mobile_no;
  } else {
    username = res.user?.email;
  }

  const handleOtpChange = (e) => {
    e.preventDefault();
    setOtp(e.target.value);
  };

  const handleResendOTP = (e) => {
    console.log("resend otp")
    setOtpResent(true);
    props.resendOtp()
  }

  const verifyOrValidate2FAToken = async () => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      if (otp) {
        const recaptcha = await generateRecaptcha('BUSINESS_LOGIN_TOKEN');
        const result = await POST(`${orgUrl}v1/auth/validate-2fa-token`, {
          token: otp,
          username,
          secret,
          recaptchaToken: recaptcha,
          source: 'WEB',
          password,
          originatedFrom: 'WIDGETS'
        });
        console.log('login response', result.data.response);
        if (result.data.response?.free_trial === true) {
          localStorage.setItem('is_free_trial_enabled', true);
        }
        saveSession(result.data.response);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setError('Require Token');
      }
    } catch (e) {
      setIsLoading(false);
      if (e.response && e.response.data)
        return setError(e.response.data.error.reason);
      setError('Invalid OTP');
    }
  };

  return (
    <div className='OTPPage'
      style={{
        background: 'white',
        display: 'block',
        width: '320px',
        height: '444px',
        boxShadow: '0px 0px 4px 0px black',
      }}
    >
      <GradientDiv>
        <div
          style={{
            position: 'absolute',
            marginTop: '24px',
            marginLeft: '24px',
          }}
        >
          <img src={AlohaaLogo} width={24} height={20} alt='alohaa'></img>
        </div>
        <p
          style={{
            position: 'absolute',
            marginTop: '60px',
            marginLeft: '24px',
            color: 'white',
            fontSize: '15px',
            fontWeight: 700,
          }}
        >
          Alohaa Login{' '}
        </p>
      </GradientDiv>
      <DailerDiv >
        <p
          style={{
            margin: '0px 110px 10px 40px',
            color: '#9B9B9B',
            font: 'Montserrat',
            fontWeight: 400,
            fontSize: '14px',
            paddingTop: '15px',
          }}
        >
          Enter OTP
        </p>
        <input
          id="username"
          type={'text'}
          value={otp}
          style={{
            height: '36px',
            width: '216px',
            display: 'block',
            margin: '0px auto',
            border: '1px solid #9B9B9B',
            borderRadius: '5px',
            marginTop: '5px',
            color: 'black',
            background: 'white',
          }}
          onChange={
            handleOtpChange
          }
        ></input>
        <p
          style={{
            margin: '10px 125px 10px 50px',
            font: 'inherit',
            fontWeight: 400,
            fontSize: '14px',
            color: '#196CCA',
            position: 'relative',
            left: '125px',
            cursor: 'pointer'
          }}
          onClick={handleResendOTP}
        >
          Resend-OTP
        </p>
        <p
          style={{
            margin: !otpResent ? '25px 25px 0px 50px' : '25px 25px 0px 70px',
            color: '#07AA3F',
            font: 'inherit',
            fontWeight: 400,
            fontSize: '15px',
            lineHeight: '15px'
          }}
        >
          {!otpResent ? (regex.test(otpSentTo) ? `OTP sent to ${otpSentTo}` : `OTP sent to +91${otpSentTo}`) : 'OTP Resent Successfully'}
        </p>
        <VerifyOtpButton
          style={{
            margin: '25px auto 0px auto',
            color: 'white',
            fontWeight: 700,
            fontSize: '14px'
          }}
          onClick={verifyOrValidate2FAToken}
        >
          Verify OTP
        </VerifyOtpButton>
        <p
          style={{
            margin: '25px 125px 10px 40px',
            font: 'inherit',
            fontWeight: 400,
            fontSize: '14px',
            color: 'black',
            position: 'relative',
            left: '90px',
            textDecoration: 'underline',
            cursor: 'pointer'
          }}
          onClick={props.handleStep}
        >Back
        </p>
      </DailerDiv>
      <div
        style={{
          color: 'red',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '15px 5px 0px 0px'
        }}
      >
        {error && (
          <React.Fragment>
            <img
              alt=""
              src={InfoRed}
              style={{
                padding: '5px 5px 0px 0px',
                position: 'relative',
                top: '-2px',
              }}
            />
            {error}
          </React.Fragment>
        )}
      </div>
    </div>
  );
}

export default TwoFAAuthentication;
